export const filter_items = [
  {
    title: "Pelin tila",
    items: [
      {
        title: "Tilanne",
        value: "bases_state",
        options: ['0', '1', '1-2', '0-2', '0-3', '1-3', '2-3', 'Ajo']
      },
      {
        title: "Palot",
        value: "outs",
        options: [0, 1, 2]
      },
      {
        title: "Lyönnin numero",
        value: "hit_number",
        options: [1, 2, 3]
      },
      {
        title: "Supervuoro",
        value: "superi",
        leagues: ['all'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
      {
        title: "Kotari",
        value: "kotari",
        leagues: ['all'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
      {
        title: "Jakso",
        value: "jakso",
        leagues: ['all'],
        options: [1, 2],
        teams: [582]
      },
      {
        title: "Vuoropari",
        value: "vuoropari",
        leagues: ['all'],
        options: [1, 2, 3, 4],
        teams: [582]
      },
      {
        title: "Lopettava vuoro",
        value: "lopettava_vuoro",
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ],
        teams: [582]
      },
    ]
  },
  {
    title: "Lyönti",
    items: [
      {
        title: "Lyöntipuoli",
        value: "hitter_side",
        options: [{
          text: "Oikea",
          value: 'R'
        }, {
          text: "Vasen",
          value: 'L'
        }]
      },
      {
        title: "Merkattu",
        value: "marked",
        leagues: ['msu', 'nsu', 'myp'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
      {
        title: "Lyönnin tyyppi",
        value: "hit_type",
        leagues: ['msu', 'nsu', 'myp'],
        options: [
          { text: "Pyke/viisto", value: "pystari/viisto" },
          { text: "Pomppu", value: "pomppu" },
          { text: "Näppi", value: "nappi" },
          { text: "Kopinnosto", value: "koppi" },
          { text: "Kumura", value: "kumura" },
          { text: "Vaakamaila", value: "vaakamaila" },
          { text: "Huti", value: "huti" },
          { text: "Pussari", value: "pussari" },
          { text: "Varsi", value: "varsi" },
          { text: "Muu", value: "muu" },
        ]
      },
      {
        title: "Tulos",
        value: "hit_outcome",
        options: [
          { text: "Vapaa", value: 'vapaa' },
          { text: "Kärkilyönti", value: 'karkilyonti' },
          { text: "Palo", value: 'palo' },
          { text: "Haava", value: 'haava' },
          { text: "Takaeteneminen", value: 'takaeteneminen' },
          { text: "Haava KT", value: 'haava_kt' },
          { text: "Takapalo", value: 'takapalo' },
        ]
      },
      {
        title: "Läpilyönti",
        value: "lapilyonti",
        leagues: ['all'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
      {
        title: "Merkki",
        value: "mark_type",
        leagues: ['msu', 'nsu'],
        removed_2026: ['msu'],
        options: [
          { text: "Lento / nopea", value: "lento" },
          { text: "Väärä pois", value: "vp" },
          { text: "Takamaila", value: "takamaila" },
          { text: "Kulmamaila", value: "kulmamaila" },
          { text: "Epäselvä maila", value: "epaselva_maila" },
          { text: "Viivästetty", value: "viivastetty" },
          { text: "Epäselvä", value: "epaselva" },
        ]
      },
      {
        title: "Eteneminen mitattu",
        value: "run_measured",
        leagues: ['msu', 'nsu', 'myp'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
    ]
  },
  {
    title: "Ulkopeli",
    leagues: ['msu', 'nsu', 'myp'],
    items: [
      {
        leagues: ['msu'],
        removed_2026: ['msu'],
        title: 'Ulkopelisuorituksen lopputulos',
        value: 'play_outcome',
        options: [
          { text: 'Onnistuminen', value: 'onnistuminen' },
          { text: 'Pakotettu epäonnistuminen', value: 'pakotettu_epaonnistuminen' },
          { text: 'Kiinniottovirhe', value: 'kiinniottovirhe' },
          { text: 'Kiinniottovirhe vapaalla lyönnillä', value: 'kiinniottovirhe_vapaalla' },
          { text: 'Harhaheitto', value: 'harhaheitto' },
          { text: 'Kiinniottovirhe pesällä', value: 'kiinniottovirhe_pesalla' },
        ]
      },
      {
        title: "Ulkopelikuvio",
        value: "outfield_formation",
        leagues: ['all'],
        removed_2026: ['myp'],
        options: [
          { group: '0-tilanne' },
          { text: "Pertsa nolla", value: "nolla_pertsa" },
          { text: "Vasuri", value: "vasuri" },
          { text: "Käännetty", value: "kaannetty" },
          { text: "3-puolen kääntö", value: "kolmospuolen_kaanto" },

          { group: 'Vaihtotilanne' },
          { text: "Normaali vaihtotilanne", value: "normaali" },
          { text: "Syvä pussi", value: "syvapussi" },
          { text: "Säilytys vaihto", value: "sailytys_vaihto" },
          { text: "Kasari", value: "kasari" },
          { text: "Nollan kuvio vaihtotilanteessa", value: "nolla_vaihdossa" },

          { group: 'Takatilanne' },
          { text: "Oulu", value: "oulu" },
          { text: "Pertsa", value: "pertsa" },
          { text: "Käännetty oulu", value: "kaannetty_oulu" },
          { text: "Käännetty pertsa", value: "kaannetty_pertsa" },
          { text: "Tahko", value: "tahko" },
          { text: "Vasurin tahko", value: "vasurin_tahko" },
          { text: "Säilytys takanen", value: "sailytys_takanen" },
          { text: "Karvaus yhdellä", value: "karvaus_yksi" },
          { text: "Karvaus kahdella", value: "karvaus_kaksi" },
          { text: "Ykköstilannekarvaus", value: "karvaus_ykkostilanne" },

        ]
      }
    ]
  },
  {
    title: "Syöttö",
    items: [
      {
        title: "Vedottu väärä",
        value: "vedottu_vaara",
        leagues: ['msu', 'nsu', 'myp'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
      {
        title: "Vedottu väärä oikea",
        value: "vvo",
        leagues: ['msu', 'nsu', 'myp'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ],
        model: 'vvo'
      },
      {
        title: "Syöttö väärin",
        value: "was_wrong",
        leagues: ['msu', 'nsu', 'myp'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ],
        model: 'was_wrong'
      },
      {
        title: "Väärä alla",
        value: "vaara_alla",
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' }
        ]
      },
      {
        title: "Väärän tyyppi",
        value: "wrong_type",
        leagues: ['msu', 'nsu'],
        removed_2026: ['msu', 'nsu'],
        options: [
          { value: 'matala', text: 'Matala' },
          { value: 'lautasvaara', text: 'Lautasväärä' },
          { value: 'linkkuvaara', text: 'Linkkuväärä' },
          { value: 'asennoton', text: 'Asennoton' },
          { value: 'muu', text: 'Muu väärä' },
        ]
      },
      {
        title: "Tolppa tai puolikas",
        value: "tall_pitch",
        leagues: ['msu', 'nsu'],
        removed_2026: ['msu', 'nsu'],
        options: [
          { text: "Kyllä", value: 'kylla' },
          { text: "Ei", value: 'ei' },
        ]
      },
    ]
  }
]

// From this season (year) onwards the reduced parameter set is used.
// Items marked with removed_2026: [league, ...] are hidden for those leagues.
export const NEW_RULES_YEAR = 2026

export function newRulesApply(seasonYear) {
  return seasonYear != null && seasonYear >= NEW_RULES_YEAR
}

// Resolve the year of a season object (parses season_name, falls back to starttime)
export function getSeasonYear(season) {
  if(!season) return null
  const match = season.season_name && String(season.season_name).match(/\d{4}/)
  if(match) return parseInt(match[0])
  if(season.starttime) {
    const d = new Date(season.starttime)
    if(!isNaN(d)) return d.getFullYear()
  }
  return null
}

// Helper function to get filtered items based on league
export function getFilteredFilterItems(filterItems, currentLeagueName) {
  return filterItems.filter(fi => {
    if(!fi.leagues) return true
    return fi.leagues.includes(currentLeagueName)
  })
}

// Helper function to get filtered items within a group
export function filterGroupItems(items, currentLeagueName, currentTeamId, seasonYear) {
  return items.filter(i => {
    if(newRulesApply(seasonYear) && i.removed_2026 && i.removed_2026.includes(currentLeagueName)) return false
    if(!i.leagues && !i.teams) return true
    else if(i.teams) {
      return i.teams.includes(currentTeamId)
    }
    else return i.leagues.includes(currentLeagueName) || i.leagues.includes('all')
  })
}

// Options of an item, taking the season into account.
// From 2026 onwards msu/nsu only use the Takatilanne formations.
export function getFilterItemOptions(item, currentLeagueName, seasonYear) {
  if(
    item.value === 'outfield_formation' &&
    newRulesApply(seasonYear) &&
    ['msu', 'nsu'].includes(currentLeagueName)
  ) {
    const takaIndex = item.options.findIndex(o => o.group === 'Takatilanne')
    return item.options.slice(takaIndex + 1)
  }
  return item.options
}